import { getConfiguration } from '@chr/common-web-ui-configuration';
import {
  AuthContext,
  Footer,
  Header,
  OnlineProvider,
  UserProfileContext, CUSTOMER_PLATFORM_THEME
} from '@chr/navisphereonline-shared-components';
import {
  OnlineTranslationProvider,
  loadMicrositeLanguage,
} from '@chr/online-shared-ui-localizations';
import * as React from 'react';
import { render } from 'react-dom';
import { initializeDatadog } from './common/Datadog/initializeDatadog';
import * as FullStory from './common/FullStory/FullStory';
import ChrLdProvider from './common/launchDarkly/ChrLdProvider';
import './index.scss';
import './polyfills';
import { AppConfig } from './react-app-env';

import { ChrThemeProvider } from '@chr/eds-react';
export const index = (async () => {
  try {
    await loadMicrositeLanguage();
    FullStory.initialize();
    const config = await getConfiguration<AppConfig>();
    const { App } = await import('./App');
    const { createStore } = await import('./createStore');
    const store = createStore(config);

    initializeDatadog(config);

    render(
      <OnlineTranslationProvider>
        <OnlineProvider appConfig={config}>
          <ChrThemeProvider theme={CUSTOMER_PLATFORM_THEME}>
            <FullStory.IdentifyUser />
            <AuthContext.Consumer>
              {authClient => <Header />}
            </AuthContext.Consumer>
            <UserProfileContext.Consumer>
              {userProfile => (
                <ChrLdProvider
                  envKey={config.launchDarklyClientId}
                  user={{ key: userProfile.userId.toString() }}
                >
                  <App store={store} />
                </ChrLdProvider>
              )}
            </UserProfileContext.Consumer>
            <Footer />
          </ChrThemeProvider>
        </OnlineProvider>
      </OnlineTranslationProvider>,
      document.getElementById('root'),
    );
  } catch (e) {
    // This is an error that can be thrown when ES modules aren't natively supported.
    // There is a pollyfill in place so we just swallow this error.
    // Temporary until we find a better error handling solution
    if (e instanceof Error && e.message.indexOf('Error resolving module') > -1) {
      return;
    }

    console.log(e);
    render(<h1>Error loading application</h1>, document.getElementById('root'));
  }
})();
